<template>
  <div class="container">
    <div class="main">
      <div class="title" > DIXCEL成为2017宝珀亚洲GT官方合作伙伴 </div>
      <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2017-3-21</div>

      <div style="line-height:30px">
        <div style="text-indent:30px"> DIXCEL作为2017宝珀亚洲GT的官方指定合作伙伴将会全程支持此次赛事。</div>  
        <div style="text-indent:30px"> 欧洲是宝珀GT的发祥地，是FIA所公认的赛事。此项赛事在欧洲取得了巨大成功，如今以欧洲作为样本，2017年在亚洲也举办此项赛事。在欧洲站所采用的由SRO运营的CT3/GT4组的BOP规则，在此次的亚洲站也会采用。</div>  
        <div style="text-indent:30px"> GT3/GT4组的赛车是一般在市场上所销售的超级赛车所改造而成。聚集了阿斯顿・马丁、奥迪、麦凯伦、宝马、法拉利、捷豹、兰博基尼、奔驰AMG、日产、保时捷等世界顶级品牌供GT3/GT4的车辆一起竞技此赛事。因为导入性能调整（BOP），所以对于每一个车队，每一个车手，每一台赛车来说都有赢得比赛的可能。从职业车手到非职业车手大家可以一起切磋也是此赛事的魅力所在。</div>  
        <div style="text-indent:30px"> 2017宝珀亚洲GT共有6场比赛（12回合），分别在4个国家6处不同的赛车场举行。首站会在4月8日-9日马来西亚举行，之后会在泰国、中国上海、中国浙江以及日本铃鹿和日本富士赛车场举行。</div>  
        <div style="text-indent:30px"> 作为该赛事的官方指定合作伙伴，DIXCEL希望可以让大家更进一步的体验此项赛事的魅力所在。</div>  

      </div>

      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_03_21/img1.png')"
          fit="fit">
        </el-image>
      </div>


    </div>
  </div>
</template>


<script>
    export default {
      data() {
        return{

        }
      }
    }
  </script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}
  .title {
    color :#ab191d;
    text-align:center;
    margin-bottom 10px
  }


</style>